var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasEpisodes)?_c('div',{staticClass:"w-player-chapters--mobile"},[_c('w-player-chapters',{on:{"play":_vm.closePanel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }